import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=770eda96&scoped=true"
import script from "./detail.vue?vue&type=script&lang=ts"
export * from "./detail.vue?vue&type=script&lang=ts"
import style0 from "./detail.vue?vue&type=style&index=0&id=770eda96&prod&lang=css"
import style1 from "./detail.vue?vue&type=style&index=1&id=770eda96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770eda96",
  null
  
)

export default component.exports